import moment from '@/utils/moment'
import { getUserData } from '@/utils/auth'
import { useStore } from '@/store'

export function loading(boolParam) {
  const store = useStore()
  store.dispatch('system/loading', boolParam).then(() => {})
}

export function formatDate(value) {
  return moment(value).format('yyyy-MM-DD')
}

export function formatTime(value) {
  return moment(value).format('HH:mm')
}

export function formatDateTime(value) {
  return moment(value).format('yyyy-MM-DD HH:mm')
}

function appendFormData(formData, key, value) {
  if (value instanceof File) {
    formData.append(key, value, value.name)
  } else if (Array.isArray(value)) {
    value.forEach((item, index) => {
      appendFormData(formData, `${key}[${index}]`, item)
    })
  } else if (typeof value === 'object' && value !== null) {
    Object.keys(value).forEach(subKey => {
      appendFormData(formData, `${key}[${subKey}]`, value[subKey])
    })
  } else {
    formData.append(key, value)
  }
}

export function objectToFormData(obj) {
  const formData = new FormData()

  // Object.keys(obj).forEach(key => {
  //   formData.append(key, obj[key])
  // })
  Object.keys(obj).forEach(key => {
    appendFormData(formData, key, obj[key])
  })

  return formData
}

export function hasRole(roleArr) {
  const userData = getUserData()
  console.log('userData.userRecord.sysUserRoles', userData.userRecord.sysUserRoles)

  // const availableRoleIDs = [1, 2, 3, 4, 7]
  const resultArr = userData.userRecord.sysUserRoles.filter(record => roleArr.includes(record.sysRoleID))
  console.log('resultArr', resultArr)
  if (resultArr.length > 0) {
    return resultArr
  }

  return []
}

export function checkTheRole(roleArr) {
  const userData = getUserData()
  console.log('userData.userRecord.sysUserRoles', userData.userRecord.sysUserRoles)

  // const availableRoleIDs = [1, 2, 3, 4, 7]
  const resultArr = userData.userRecord.sysUserRoles.filter(record => roleArr.includes(record.sysRoleID))
  console.log('resultArr', resultArr)
  if (resultArr.length > 0) {
    return true
  }

  return false
}


export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export async function base64ToFile(base64Str, fileName) {
  // const byteString = atob(base64Str.split(',')[1])
  // const arrayBuffer = new ArrayBuffer(byteString.length)
  // const intArray = new Uint8Array(arrayBuffer)

  // for (let i = 0; i < byteString.length; i += 1) {
  //   intArray[i] = byteString.charCodeAt(i)
  // }

  // const mimeType = base64Str.split(',')[0].split(':')[1].split(';')[0]

  // return new File([intArray], fileName, { type: mimeType })
  const response = await fetch(base64Str)
  const blob = await response.blob()

  return new File([blob], fileName, { type: blob.type })
}

// p1: dateString
export function getStartOfMonth(dateString) {
  const date = moment(dateString)

  const firstDayOfMonth = date.startOf('month')

  return firstDayOfMonth.format('YYYY-MM-DD')
}

export function handleSelectionResponse(res, itemNameProp = 'description', callback) {
  const items = []
  if (res.data.items && res.data.items.length > 0) {
    res.data.items.forEach(item => {
      let clone = { ...item }
      clone.itemValue = item.id
      clone.itemName = item[itemNameProp]
      clone.label = item[itemNameProp]
      if (callback) {
        clone = callback(clone)
      }
      items.push(clone)
    })
  }

  return items
}
